module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.category) ? _c('div', [_c('div', {
    staticClass: "uploaderBox",
    attrs: {
      "id": "uploaderBox"
    }
  }, [_c('div', {
    staticClass: "uploaderBox__input"
  }, [_c('input', {
    staticClass: "uploaderBox__file",
    attrs: {
      "type": "file",
      "id": "file",
      "name": _vm.uploadFieldName,
      "accept": _vm.accept,
      "multiple": ""
    },
    on: {
      "change": function($event) {
        _vm.filesChange($event.target.files)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "allChildrenCenter flex-column"
  }, [_c('label', {
    attrs: {
      "for": "file"
    }
  }, [(_vm.category == 'audio') ? _c('img', {
    staticClass: "uploaderBox_image",
    attrs: {
      "src": require('@/assets/upload-music.png')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.category == 'video') ? _c('img', {
    staticClass: "uploaderBox_image",
    attrs: {
      "src": require('@/assets/upload-video.png')
    }
  }) : _vm._e(), _vm._v(" "), (_vm.category == 'product') ? _c('img', {
    staticClass: "uploaderBox_image",
    attrs: {
      "src": "/static/images/upload.png"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "uploaderBox__desc"
  }, [(_vm.category == 'audio') ? _c('div', [_c('b', {
    staticClass: "uploaderBox__dragndrop"
  }, [_vm._v("\n                  Drag and drop audio files\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.category == 'video') ? _c('div', [(_vm.category == 'video') ? _c('b', {
    staticClass: "uploaderBox__dragndrop"
  }, [_vm._v("\n                  Drag and drop video files\n                ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.category == 'product') ? _c('div', [(_vm.category == 'product') ? _c('b', {
    staticClass: "uploaderBox__dragndrop"
  }, [_vm._v("\n                  Drag and drop product files\n                ")]) : _vm._e()]) : _vm._e()])])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6498f406","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dragFileUploader.vue
// module id = 1753
// module chunks = 180